

























































































































































































import Vue from "vue";

export default Vue.extend({
  props: {
    values: {
      type: Array as () => Array<any>,
      default: () => [] as any[]
    }
  },

  data() {
    return {
      def: {
        starts: [],
        ends: [],
        intervals: []
      },
      dayLabels: {
        def: "Default",
        mon: "Monday",
        tue: "Tuesday",
        wed: "Wednesday",
        thu: "Thursday",
        fri: "Friday",
        sat: "Saturday",
        sun: "Sunday",
      },
      days: {
        mon: {
          enabled: true,
          overwrite: "no",
          starts: [],
          ends: [],
          intervals: []
        },
        tue: {
          enabled: true,
          overwrite: "no",
          starts: [],
          ends: [],
          intervals: []
        },
        wed: {
          enabled: true,
          overwrite: "no",
          starts: [],
          ends: [],
          intervals: []
        },
        thu: {
          enabled: true,
          overwrite: "no",
          starts: [],
          ends: [],
          intervals: []
        },
        fri: {
          enabled: true,
          overwrite: "no",
          starts: [],
          ends: [],
          intervals: []
        },
        sat: {
          enabled: true,
          overwrite: "no",
          starts: [],
          ends: [],
          intervals: []
        },
        sun: {
          enabled: true,
          overwrite: "no",
          starts: [],
          ends: [],
          intervals: []
        }
      },
      fields: [
        {
          key: "enabled",
          fieldTag: "input",
          fieldType: "radio",
          label: "Enabled",
          options: [
            {
              label: "No",
              value: false
            },
            {
              label: "Yes",
              value: true
            }
          ]
        },
        {
          key: "overwrite",
          fieldTag: "input",
          fieldType: "radio",
          label: "Overwrite",
          options: [
            {
              label: "No",
              value: false
            },
            {
              label: "Yes",
              value: true
            }
          ]
        },
        {
          key: "starts",
          fieldTag: "input",
          fieldType: "text",
          label: "Starts"
        },
        {
          key: "ends",
          fieldTag: "input",
          fieldType: "text",
          label: "Ends"
        },
        {
          key: "intervals",
          fieldTag: "input",
          fieldType: "text",
          label: "Intervals"
        }
      ]
    };
  },

  computed: {
    schedule: {
      get() {
        const schedule = [this.def] as any[];
        Object.entries(this.days).forEach(([key, day]) => {
          if (!day.enabled) {
            schedule.push({ day: key, enabled: false });
          } else if (day.overwrite) {
            schedule.push({ day: key, ...day });
          } else {
            schedule.push({ day: key, enabled: true, overwrite: false });
          }
        });
        return schedule;
      },
      set(schedule) {}
    }
  },

  created() {
    const def = Object.assign(
      this.def,
      this.values.find(day => day.day === "def")
    );
    this.def = def;
    this.values.forEach(day => {
      if (day.day !== "def") {
        this.$set(this.days, day.day, Object.assign(this.days[day.day], day));
      }
    });
  }
});
